import _defineProperty from '@babel/runtime/helpers/defineProperty';
import { darkTheme, defaultTheme } from './Theme.js';
import { createTheme } from './create-theme.js';
import { inPixels } from '../helpers/style.js';
import { colors } from '../../constants/colors.js';

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), true).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var legacyThemePalette = {
  primary: colors.oceanGreen,
  alert: colors.punchRed,
  text: colors.inkGrey,
  info: colors.cushyBlue,
  background: colors.snowWhite
};
var legacyThemePaletteDark = {
  primary: colors.poweringGreen,
  alert: colors.softRed,
  text: colors.cloudGrey,
  info: colors.waterBlue,
  background: colors.professionalGrey
};
/**
 *  A helper for generating a legacy theme variant
 *
 *  Used to generate the legacy boxy theme like
 *
 *  generateLegacyTheme({
 *    borderRadius: 0,
 *    colorScheme: 'legacy',
 *    baseTheme: 'light',
 * });
 */

var generateLegacyTheme = function generateLegacyTheme(options) {
  var baseTheme = options.baseTheme === 'dark' ? darkTheme : defaultTheme;
  var themeProperties = typeof options.borderRadius === 'number' ? {
    borders: {
      radius: inPixels(options.borderRadius)
    },
    datepicker: {
      "native": {
        datePickerButton: {
          borderRadius: 0
        }
      }
    }
  } : {};
  if (options.colorScheme === 'legacy') {
    return createTheme(_objectSpread(_objectSpread({}, themeProperties), {}, {
      colors: options.baseTheme === 'dark' ? legacyThemePaletteDark : legacyThemePalette,
      tokens: {
        notification: {
          alert: {
            text: colors.rubyRed,
            background: colors.blushRed
          },
          info: {
            text: colors.broadBlue,
            background: colors.babyBlue
          },
          primary: {
            text: colors.emeraldGreen,
            background: colors.hyperGreen
          },
          warning: {
            text: colors.inkGrey,
            background: colors.miniYellow
          }
        }
      }
    }), baseTheme);
  }
  return createTheme(themeProperties, baseTheme);
};

export { generateLegacyTheme, legacyThemePalette, legacyThemePaletteDark };
